<template>
    <Transition name="pop">
        <div id="LoginPop" class="pop" v-if="state.show">
            <div class="content">
                <span class="close" @click="state.show = false"></span>
                <div class="header"></div>
                <div class="middle"></div>
                <div class="footer"></div>
                <h1>盛趣通行证登录</h1>
                <div class="iframe-wrapper">
                    <iframe
                        width="100%"
                        height="410"
                        :src="`https://actxyx.web.sdo.com/api/sdo/Login.aspx?activeid=260911&&random=${state.random}`"
                        frameborder="0"
                    ></iframe>
                </div>
            </div>
        </div>
    </Transition>
</template>

<script setup>
import { reactive } from "vue";

const state = reactive({
    show: false,
    random: Math.random()
});

defineExpose({
    Show: () => {
        state.show = true;
    },
    Hide: () => {
        state.show = false;
    },
    Refresh: () => {
        state.random = Math.random();
    }
});
</script>

<style lang="scss" scoped>
#LoginPop {
    .content {
        background: #fff;
    }
}
</style>
